
import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { TypesModel } from "./types-data-model";

export class TypesGridModel extends TypesModel { }

export class TypesListingModel extends GridModel<TypesGridModel> { }

export class TypesGridParams extends GridPostParams {
  
    pageNumber:any= 1;
    pageSize:any= 10;
    search_keyword:any= '';
    direction:any= '';
    column:any= '';
    id:any= 40;
    
}